import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { getToken, removeToken } from '@/utils/auth'

export default new Vuex.Store({
  state: {
    token: getToken(),
    viewIdx: '', //当前组件
    viewIdxgran: '',
    appCode: 'KTJXPJ', //
    schoolId: '',
    roleId: '',
    orgId: '',
    roleType: '',
    schoolName: ''
  },
  mutations: {
    Idxs(state, data) {
      state.viewIdx = data
    },
    Idxsgran(state, data) {
      state.viewIdxgran = data
    },
    code(state, data) {
      state.code = data
    },
    course_type(state, data) {
      state.course_type = data
    },

    setClassDataH5(state, data) {
      state.classDataH5 = data
    },
    setSchoolId(state, data) {
      state.schoolId = data
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    setRoleId(state, data) {
      state.roleId = data
    },

    setOrgId(state, data) {
      state.orgId = data
    },

    setRoleType(state, data) {
      state.roleType = data
    },

    setSchoolName(state, data) {
      state.schoolName = data
    },

  },
  actions: {
    // 前端 登出
    FedFedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer(state) {
        return {
          token: state.token,
          viewIdx: state.viewIdx,
          viewIdxgran: state.viewIdxgran,
          appCode: state.appCode,
          schoolId: state.schoolId,
          roleId: state.roleId,
          orgId: state.orgId,
          roleType: state.roleType,
          schoolName: state.schoolName,

        }
      },
    }),
  ],
})
